export interface FailedFetchErrorProps {
  // tslint:disable-next-line:no-any
  error: Error | any;
  method: string;
  path: string;
}

export default class FailedFetchError extends Error {
  method: string;
  originalName: string;
  path: string;
  stack?: string;
  status: number;

  constructor({ error, path, method }: FailedFetchErrorProps) {
    super();
    this.name = 'FailedFetchError';
    this.message = error.message;
    this.stack = error.stack;
    this.status = error.status;
    this.originalName = error.name;
    this.method = method;
    const p = path.split('?')[0];
    this.path = /^[/-a-z]+$/i.test(p) ? p : '';
  }
}
